import { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import AddButtonIcon from '@/assets/icon-add-left.svg?react';
import AddTextIcon from '@/assets/icon-add-right.svg?react';
import PaperclipIcon from '@/assets/icon-paperclip.svg?react';
import DocumentIcon from '@/assets/icon-google-document.svg?react';
import useElysiaStore from '@/app/elysia-store';

const AddResourceDropdown = ({ onAddSources, onAttachFileClick }) => {
  const chatAgent = useElysiaStore((state) => state.chatAgent);
  const uploadedFileTitle = useElysiaStore((state) => state.uploadedFileTitle);
  const isChatDisabled = useElysiaStore((state) => state.isChatDisabled);
  const isAddSourcesActive = useElysiaStore((state) => state.isAddSourcesActive);
  const isAppPreview = useElysiaStore((state) => state.isAppPreview);
  const promptToolsConfig = useElysiaStore((state) => state.promptToolsConfig);

  const [show, setShow] = useState(false);

  const handleToggle = () => {
    setShow(!show);
  };
  return (
    <>
      <Dropdown show={show} onToggle={handleToggle} drop="up">
        <Dropdown.Toggle
          variant="light"
          id="chat-widget-dropdown"
          className={`add-resource ${chatAgent === 'Document' || isAddSourcesActive ? 'selected' : ''}`}
          aria-label="Add resource"
        >
          <div className="d-flex justify-content-center align-items-center gap-1">
            <AddButtonIcon />
            <AddTextIcon />
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className="resources-dropdown">
          {!isAppPreview && promptToolsConfig.attachFiles && (
            <Dropdown.Item
              as="button"
              onClick={onAttachFileClick}
              disabled={
                uploadedFileTitle?.length > 0 ||
                chatAgent === 'Document' ||
                isChatDisabled ||
                isAddSourcesActive
              }
            >
              <PaperclipIcon />
              Attach file
            </Dropdown.Item>
          )}
          {promptToolsConfig.addSources && (
            <Dropdown.Item
              as="button"
              onClick={onAddSources}
              active={chatAgent === 'Document'}
              disabled={uploadedFileTitle?.length > 0 || isChatDisabled}
              aria-label="Add sources"
            >
              <DocumentIcon />
              Add sources
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default AddResourceDropdown;
